import { render } from "./AlbumTrack.vue?vue&type=template&id=412fe52b&scoped=true"
import script from "./AlbumTrack.vue?vue&type=script&lang=js"
export * from "./AlbumTrack.vue?vue&type=script&lang=js"

import "./AlbumTrack.vue?vue&type=style&index=0&id=412fe52b&scoped=true&lang=scss"

import exportComponent from "/Users/michellmonroy/Documents/dev-glider/catalogue-api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412fe52b"]])

export default __exports__